import manager from '@mailobj-browser/front/js/contracts/manager.js'
import resolvable from '@mailobj-browser/front/js/utils/resolvable.js'
import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import afterPrint from '@mailobj-browser/front/js/events/types/afterPrint.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'

const [promise, { resolve }] = resolvable()

const onAfterPrint = object(listener, {
  type: afterPrint,
  passive,
  task: async () => {
    await promise
    globalThis.close()
  }
})

export default () => {
  const ready = manager.ready()
  onAfterPrint.listen(globalThis)

  queueMicrotask(async () => {
    await ready
    globalThis.print()
    resolve()
  })
}
